import FollowingPageFilterDropdown from './FollowingPageFilterDropdown';
import NewDiscussionNotification from './NewDiscussionNotification';
import NewDiscussionTagNotification from './NewDiscussionTagNotification';
import NewPostNotification from './NewPostNotification';
import SubscriptionModal from './SubscriptionModal';
import SubscriptionOptionItem from './SubscriptionOptionItem';
import SubscriptionStateButton from './SubscriptionStateButton';

export const components = {
  FollowingPageFilterDropdown,
  NewDiscussionNotification,
  NewDiscussionTagNotification,
  NewPostNotification,
  SubscriptionModal,
  SubscriptionOptionItem,
  SubscriptionStateButton,
};
